import { From, IModelMetadata, nameof, TwoWayAdapter } from '@bds/core';
import { Injectable } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { FormGroupDescription } from './adapter_t';

export class RtRailroadPartner implements From<RtRailroadPartner> {
    constructor(public ormId?: number, public rrScac?: string, public rrPartnerScac?: string) {}
    from(partner: RtRailroadPartner): RtRailroadPartner {
        Object.keys(partner).forEach((k) => (this[k] = partner[k]));
        return this;
    }
}

export interface RtRailroadPartnerModel {
    partnerRailroads: RtRailroadPartner[];
}

export const relationship: IModelMetadata[] = [
    { client: nameof<RtRailroadPartner>('ormId'), server: 'ormId' },
    { client: nameof<RtRailroadPartner>('rrScac'), server: 'rrScac' },
    { client: nameof<RtRailroadPartner>('rrPartnerScac'), server: 'rrPartnerScac' },
];

@Injectable({
    providedIn: 'root',
})
export class RtRailroadPartnerAdapter extends TwoWayAdapter<RtRailroadPartner> {
    constructor() {
        super();
    }
    public metadata: IModelMetadata[] = relationship;
}

// https://www.devexpress.com/Support/Center/Question/Details/T746351/datagrid-how-to-set-columns-at-runtime
@Injectable({
    providedIn: 'root',
})
export class RtRailroadPartnerMetadata implements FormGroupDescription {
    constructor() {}
    getFormGroup(obj?: any): UntypedFormGroup {
        const formGroup = new UntypedFormGroup({});
        formGroup.addControl(
            nameof<RtRailroadPartner>('ormId'),
            new UntypedFormControl('', [Validators.required, Validators.min(0)]),
        );
        formGroup.addControl(
            nameof<RtRailroadPartner>('rrScac'),
            new UntypedFormControl('', [Validators.required]),
        );
        formGroup.addControl(
            nameof<RtRailroadPartner>('rrPartnerScac'),
            new UntypedFormControl('', [Validators.required]),
        );
        if (!!obj) {
            formGroup.patchValue(obj);
        }
        return formGroup;
    }
}
